export enum Languages {
  HE = 'he',
  EN = 'en',
}
